import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
// import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import translationEN from 'utility/locales/en.json';
import translationBS from 'utility/locales/bs.json';
import translationMK from 'utility/locales/mk.json';
import translationSQ from 'utility/locales/sq.json';
import translationSR from 'utility/locales/sr.json';
import translationCNR from 'utility/locales/cnr.json';

// const basePath = window.location.hostname === 'localhost' ? "https://localhost:7111/" : "/";
// var basePath = "https://dev.194-36-88-104.cloud-xip.com/api/public";

const resources = {
    mk: {
        translation: translationMK
    },
    bs: {
        translation: translationBS
    },
    sr: {
        translation: translationSR
    },
    al: {
        translation: translationSQ
    },  
    en: {
        translation: translationEN
    },
    me:{
        translation: translationCNR
    }
}

const options = {
    order: ["navigator", "localStorage"],
    caches: ["localStorage"],
    resources,
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    load: "currentOnly",
    saveMissing: true, // send not translated keys to endpoint
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    nsSeparator: false,
    keySeparator: false,
};


i18n.use(initReactI18next).init(options);